@if (items?.length || hiddenResultsPreview?.length) {
  @if (hasTitle() && title) {
    <div layout-horizontal margin-bottom>
      <rt-heading
        (click)="toggle()"
        class="expand-completed"
        variant="heading space-bottom text-color"
      >
        <rt-icon [name]="state.expanded ? 'expand-more' : 'expand-less'" [size]="'medium'" />
        {{ title }}
      </rt-heading>
      @if (offer && hasMoreThanOneJob()) {
        <rt-divider variant="dot" />
        {{ offer.title }}
      }
      <div
        class="evaluation-rating"
        layout-horizontal
        layout-align-items-center
        layout-flex-1
        layout-justify-flex-end
      >
        @if (hasRating()) {
          <span>{{
            (hiddenResultsPreview?.length
              ? 'app.interview.hidden_score'
              : 'app.interview.positive_rate'
            ) | translate
          }}</span>
          @if (hiddenResultsPreview?.length) {
            <rt-icon [name]="'visibility-off'" margin-left-small-x />
          }
          @if (!hiddenResultsPreview?.length) {
            <rt-interview-evaluation-rating [rating]="rating()!" [size]="'small'" />
            <strong>{{ rating() }}%</strong>
          }
        } @else {
          <div>{{ 'app.interview.no_score' | translate }}</div>
        }
      </div>
    </div>
  }
  <div [class.hidden]="!state.expanded" [class.short]="short()" layout-vertical>
    @if (hiddenResultsPreview?.length) {
      @for (hiddenResultPreview of hiddenResultsPreview; track hiddenResultPreview.id) {
        @if (hiddenEvaluationsInfoboxTpl(); as infoboxTpl) {
          <ng-container
            *ngTemplateOutlet="
              infoboxTpl;
              context: {
                $implicit: hiddenResultPreview,
                offers: state.offers,
                candidateId: candidateId(),
                canReveal: abilities.reviewHiddenEvaluations,
                hasAccessToJob: hasAccessToJob(hiddenResultPreview.offerId),
                isJobNameVisible:
                  hiddenEvaluationsJobNameVisible && (candidatePlacements()?.length || 0) > 1,
                isButtonsVisible:
                  groupBy() !== 'stage' ||
                  isCurrentStage(hiddenResultPreview.offer, hiddenResultPreview.stage),
                groupBy: groupBy(),
              }
            "
          />
        } @else {
          <rt-hidden-evaluations-infobox
            [guests]="hiddenResultPreview.guests"
            [admins]="$any(hiddenResultPreview.admins)"
            [count]="hiddenResultPreview.count"
            [offer]="hiddenResultPreview.offer"
            [stage]="$any(hiddenResultPreview.stage)"
            [isJobNameVisible]="
              hiddenEvaluationsJobNameVisible && (candidatePlacements()?.length || 0) > 1
            "
            [isButtonsVisible]="
              groupBy() !== 'stage' ||
              isCurrentStage(hiddenResultPreview.offer, hiddenResultPreview.stage)
            "
            [groupBy]="groupBy()"
            [short]="false"
            [offers]="state.offers"
            [templates]="state.templates"
            [candidateId]="candidateId()"
            [canReveal]="abilities.reviewHiddenEvaluations"
            [hasAccessToJob]="hasAccessToJob(hiddenResultPreview.offerId)"
            (quickEvaluationClick)="quickEvaluationClick.emit($event)"
            (revealClick)="
              onReviewHiddenEvaluationsClick(
                hiddenResultPreview.offer,
                $safeNavigationMigration(hiddenResultPreview?.stage)
              )
            "
            margin-bottom-small
          />
        }
      }
    }
    @if (items?.length) {
      @for (item of items; track item.id) {
        @switch (type()) {
          @case ('request') {
            <rt-interview-result-request-card
              [currentAdmin]="state.currentAdmin!"
              [openCandidateOnClick]="true"
              [openEventModalOnClick]="openEventModalOnClick()"
              [inCandidate]="inCandidate()"
              [request]="$any(item)"
              [short]="short()"
              [inDashboard]="inDashboard()"
              [candidateId]="$safeNavigationMigration(item.candidate?.id)"
              [hasHighLevelDataAccess]="abilities.highLevelDataAccess"
              [dialogRef]="dialogRef()"
            />
          }

          @case ('result') {
            <rt-interview-result-card
              cachedQuickEvaluationFormOpener
              [currentAdmin]="state.currentAdmin!"
              [result]="$any(item)"
              [edit]="edit()"
              [candidate]="item.candidate"
              [hasHeader]="hasHeader()"
              [isFairEvalEnabledForStage]="hasPlacementFairEvalEnabled(item.offerId)"
              [hasEvaluationPanel]="hasEvaluationPanel"
              [ratingLevelTranslations]="ratingLevelTranslations()"
              [abilities]="abilities"
            />
          }
        }
      }
    }
  </div>
}
